// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-line-wrapper[data-v-77ca0304]{font-weight:600;background:transparent;border:1px solid #ececec;padding:20px;border-radius:20px}.table-line-wrapper.large-line[data-v-77ca0304]{height:250px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
